export const styles = {
  detailContent: 'tw-flex tw-flex-col tw-gap-4',
  modalFormContent: 'tw-flex tw-flex-col tw-gap-4',
  confirmationMessage: 'tw-text-sm tw-text-neutral-700',
};
